import React, { useEffect, useState } from 'react';

import { relativeAPI, parentDeviceAPI } from '../../api/client';
import { PageHeader } from '../../components/UI';
import T from '../../theme';

const RELATION_TYPES = [
  { value: 'father', label: 'Ota', icon: '👨' },
  { value: 'mother', label: 'Ona', icon: '👩' },
  { value: 'grandfather', label: 'Bobiy', icon: '👴' },
  { value: 'grandmother', label: 'Buvi', icon: '👵' },
  { value: 'uncle', label: "Amaki/Tog'a", icon: '👨' },
  { value: 'aunt', label: 'Xola/Amma', icon: '👩' },
  { value: 'brother', label: 'Aka/Uka', icon: '👦' },
  { value: 'sister', label: 'Opa/Singil', icon: '👧' },
  { value: 'other', label: 'Boshqa', icon: '👤' },
];

function RelativeCard({ rel, onDelete, onEdit }) {
  const [h, setH] = useState(false);
  const rt = RELATION_TYPES.find(r => r.value === rel.relation_type) || RELATION_TYPES[8];
  return (
    <div onMouseEnter={() => setH(true)} onMouseLeave={() => setH(false)} style={{
      background: '#fff', borderRadius: 20, padding: '20px', boxShadow: h ? T.shadowHover : T.shadow,
      border: `2px solid ${h ? T.orange + '30' : T.border}`, transition: 'all 0.3s',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 14 }}>
        <div style={{
          width: 52, height: 52, borderRadius: 16, background: '#FFF7ED',
          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 26,
        }}>{rt.icon}</div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 17, fontWeight: 800, color: T.text }}>{rel.full_name}</div>
          <div style={{ fontSize: 14, color: T.orange, fontWeight: 700, marginTop: 2 }}>{rel.relation_type_display}</div>
        </div>
        <div style={{
          padding: '4px 12px', borderRadius: 10, fontSize: 12, fontWeight: 800,
          background: rel.is_active ? T.blueSoft : '#FEF2F2',
          color: rel.is_active ? T.blueDark : '#DC2626',
        }}>{rel.is_active ? '● Faol' : '○ Nofaol'}</div>
      </div>

      {/* Phone */}
      <div style={{ background: '#F9FAFB', borderRadius: 12, padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
        <span style={{ fontSize: 16 }}>📱</span>
        <span style={{ fontSize: 14, fontWeight: 700, color: T.text, fontFamily: T.mono }}>{rel.phone}</span>
      </div>

      {/* Connected devices */}
      {rel.devices_list && rel.devices_list.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 14 }}>
          {rel.devices_list.map(d => (
            <span key={d.id} style={{
              padding: '4px 10px', borderRadius: 8, background: T.blueSoft, fontSize: 12, fontWeight: 700, color: T.blueDark,
            }}>📡 {d.child_name || d.imei}</span>
          ))}
        </div>
      )}

      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={() => onEdit(rel)} style={{ flex: 1, padding: '10px', background: '#FFF7ED', border: 'none', borderRadius: 12, fontSize: 14, fontWeight: 700, color: T.orange, cursor: 'pointer', fontFamily: T.font }}>✏️ Tahrirlash</button>
        <button onClick={() => onDelete(rel.id)} style={{ padding: '10px 16px', background: '#FEF2F2', border: 'none', borderRadius: 12, fontSize: 14, fontWeight: 700, color: '#DC2626', cursor: 'pointer', fontFamily: T.font }}>🗑</button>
      </div>
    </div>
  );
}

function RelativeForm({ editData, devices, onSave, onCancel }) {
  const [fullName, setFullName] = useState(editData?.full_name || '');
  const [relationType, setRelationType] = useState(editData?.relation_type || 'other');
  const [phone, setPhone] = useState(editData?.phone || '');
  const [selectedDevices, setSelectedDevices] = useState(
    editData?.devices || []
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const inp = { width: '100%', padding: '13px 16px', background: '#F9FAFB', border: `2px solid ${T.border}`, borderRadius: 12, fontSize: 15, fontFamily: T.font, fontWeight: 600, color: T.text, outline: 'none', boxSizing: 'border-box' };

  const toggleDevice = (id) => {
    setSelectedDevices(prev =>
      prev.includes(id) ? prev.filter(d => d !== id) : [...prev, id]
    );
  };

  const handleSubmit = async () => {
    if (!fullName.trim()) { setError('Ism kiritilmagan'); return; }
    if (!phone.trim()) { setError('Telefon kiritilmagan'); return; }
    setLoading(true); setError('');
    try {
      await onSave({
        full_name: fullName,
        relation_type: relationType,
        phone,
        device_ids: selectedDevices,
      });
    } catch (err) {
      const d = err.response?.data;
      setError(typeof d === 'object' ? Object.values(d).flat().join(', ') : 'Xatolik');
    }
    setLoading(false);
  };

  return (
    <div style={{ background: '#fff', borderRadius: 20, padding: '28px', boxShadow: T.shadow }}>
      <h3 style={{ fontSize: 18, fontWeight: 900, color: T.text, marginBottom: 20 }}>
        👤 {editData ? 'Qarindoshni tahrirlash' : 'Yangi qarindosh'}
      </h3>
      {error && <div style={{ background: '#FEF2F2', color: '#DC2626', padding: '10px 14px', borderRadius: 12, fontSize: 14, fontWeight: 700, marginBottom: 14 }}>⚠️ {error}</div>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        <input style={inp} value={fullName} onChange={e => setFullName(e.target.value)} placeholder="To'liq ismi" />
        <input style={{ ...inp, fontFamily: T.mono }} value={phone} onChange={e => setPhone(e.target.value)} placeholder="+998901234567" />

        <div>
          <label style={{ fontSize: 13, fontWeight: 800, color: T.textSec, display: 'block', marginBottom: 8 }}>QARINDOSHLIGI</label>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 6 }}>
            {RELATION_TYPES.map(rt => (
              <button key={rt.value} onClick={() => setRelationType(rt.value)} style={{
                padding: '10px 6px', background: relationType === rt.value ? '#FFF7ED' : '#F9FAFB',
                border: `2px solid ${relationType === rt.value ? T.orange : T.border}`, borderRadius: 10,
                cursor: 'pointer', fontFamily: T.font, fontSize: 12, fontWeight: 700,
                color: relationType === rt.value ? T.orange : T.textSec, transition: 'all 0.2s',
              }}>
                <div style={{ fontSize: 18, marginBottom: 2 }}>{rt.icon}</div>
                {rt.label}
              </button>
            ))}
          </div>
        </div>

        {devices.length > 0 && (
          <div>
            <label style={{ fontSize: 13, fontWeight: 800, color: T.textSec, display: 'block', marginBottom: 8 }}>QAYSI BOLALARNI KUZATA OLADI?</label>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              {devices.map(d => {
                const selected = selectedDevices.includes(d.id);
                return (
                  <button key={d.id} onClick={() => toggleDevice(d.id)} style={{
                    padding: '12px 14px', background: selected ? T.blueSoft : '#F9FAFB',
                    border: `2px solid ${selected ? T.blue : T.border}`, borderRadius: 12,
                    cursor: 'pointer', fontFamily: T.font, fontSize: 14, fontWeight: 700,
                    color: selected ? T.blueDark : T.textSec, display: 'flex', alignItems: 'center', gap: 10,
                    transition: 'all 0.2s', textAlign: 'left',
                  }}>
                    <span style={{
                      width: 22, height: 22, borderRadius: 6, border: `2px solid ${selected ? T.blue : '#D1D5DB'}`,
                      background: selected ? T.blue : '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: 12, color: '#fff',
                    }}>{selected ? '✓' : ''}</span>
                    📡 {d.child_info?.name || d.imei}
                  </button>
                );
              })}
            </div>
          </div>
        )}

        <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
          <button onClick={onCancel} style={{ flex: 1, padding: '14px', background: '#F9FAFB', border: `2px solid ${T.border}`, borderRadius: 14, fontSize: 16, fontWeight: 700, cursor: 'pointer', color: T.textSec, fontFamily: T.font }}>Bekor</button>
          <button onClick={handleSubmit} disabled={loading} style={{
            flex: 2, padding: '14px', background: loading ? '#EFF6FF' : `linear-gradient(135deg, ${T.blue}, ${T.blueLight})`,
            color: '#fff', border: 'none', borderRadius: 14, fontSize: 16, fontWeight: 800,
            cursor: 'pointer', fontFamily: T.font, boxShadow: '0 4px 16px rgba(16,185,129,0.25)',
          }}>{loading ? 'Saqlanmoqda...' : 'Saqlash ✓'}</button>
        </div>
      </div>
    </div>
  );
}

export default function RelativesPage() {
  const [relatives, setRelatives] = useState([]);
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editData, setEditData] = useState(null);

  const loadData = async () => {
    try {
      const [rRes, dRes] = await Promise.all([relativeAPI.list(), parentDeviceAPI.list()]);
      setRelatives(rRes.data);
      setDevices(dRes.data);
    } catch {}
    setLoading(false);
  };

  useEffect(() => { loadData(); }, []);

  const handleSave = async (data) => {
    if (editData) {
      await relativeAPI.update(editData.id, data);
    } else {
      await relativeAPI.create(data);
    }
    setShowForm(false); setEditData(null);
    await loadData();
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Haqiqatan ham o'chirmoqchimisiz?")) return;
    await relativeAPI.delete(id);
    await loadData();
  };

  return (
    <div>
      <PageHeader title="👨‍👩‍👧 Qarindoshlar" />
      <div style={{ maxWidth: 700 }}>
        {!showForm && (
          <button onClick={() => { setEditData(null); setShowForm(true); }} style={{
            width: '100%', padding: '16px', marginBottom: 20,
            background: '#fff', border: `2px dashed ${T.orange}50`, borderRadius: 18,
            fontSize: 16, fontWeight: 800, color: T.orange, cursor: 'pointer', fontFamily: T.font,
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
          }}>
            <span style={{ fontSize: 20 }}>＋</span>
            Qarindosh qo'shish
          </button>
        )}

        {showForm && (
          <div style={{ marginBottom: 20 }}>
            <RelativeForm
              editData={editData} devices={devices}
              onSave={handleSave} onCancel={() => { setShowForm(false); setEditData(null); }}
            />
          </div>
        )}

        {loading ? (
          <p style={{ textAlign: 'center', color: T.textSec, padding: 40 }}>Yuklanmoqda...</p>
        ) : relatives.length === 0 && !showForm ? (
          <div style={{ textAlign: 'center', padding: '50px 20px', background: '#fff', borderRadius: 20, boxShadow: T.shadow }}>
            <div style={{ fontSize: 56, marginBottom: 14 }}>👨‍👩‍👧</div>
            <h3 style={{ fontSize: 20, fontWeight: 900, color: T.text, marginBottom: 8 }}>Hali qarindosh yo'q</h3>
            <p style={{ fontSize: 15, color: T.textSec, lineHeight: 1.7 }}>Qarindoshlar ham bolaning joylashuvini<br />kuzata oladi</p>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {relatives.map(r => (
              <RelativeCard key={r.id} rel={r} onDelete={handleDelete} onEdit={(rel) => { setEditData(rel); setShowForm(true); }} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
